import axios from 'axios'
import authHeader from './AuthHeader'
import { API_URL } from '../config/api'

class ExpensesService {
   
    getExpenses = async (pageNum, search = '', limit = false, sortBy = 'name', sortOrder = 'asc', providerId = '', searchYear = '') => {
         let url = `${API_URL}/expenses?page=${pageNum}&search=${search}&limit=${limit}&sortBy=${sortBy}&sortOrder=${sortOrder}&providerId=${providerId}`

        // Si hay un año, lo agregamos como parámetro
        if (searchYear) {
            url += `&year=${searchYear}`
        }

        return await axios.get(url, { headers: authHeader() })
    }
        

    // Add new expense
    addExpense = async (expense) => {
        return await axios.post(API_URL + '/expenses', expense, { headers: authHeader() })
    }

    // Update expense data
    updateExpense = async (expense, id) => {
        return await axios.patch(API_URL + '/expenses/' + id, expense, { headers: authHeader() })
    }

    // Get expense data
    getExpense = async (id) => {
        return await axios.get(API_URL + '/expenses/' + id, { headers: authHeader() })
    }

    // Delete expense
    deleteExpense = async (id) => {
        return await axios.delete(API_URL + '/expenses/' + id, { headers: authHeader() })
    }

    // Get expenses chart dataset
    getExpensesDataset = async ({ providerId = '', yearFrom = '', yearTo = '' }) => {
        // Crear una base de la URL
        let url = API_URL + '/dataset/expenses?'

        // Añadir parámetros opcionales si existen
        if (providerId) {
            url += `providerId=${providerId}&`
        }
        if (yearFrom) {
            url += `yearFrom=${yearFrom}&`
        }
        if (yearTo) {
            url += `yearTo=${yearTo}&`
        }

        // Eliminar el último '&' si lo hay
        url = url.endsWith('&') ? url.slice(0, -1) : url
        return await axios.get(url, { headers: authHeader() })
    }
}

export default new ExpensesService()